export default "__VITE_ASSET__BzD_CPbI__"